import axios from 'axios';

import { CRM_API_ENDPOINT } from 'constants/api';

const crmApi = axios.create({
  baseURL: CRM_API_ENDPOINT,
});

export default crmApi;
